
export enum OrderItemKind {
  Sale= 'Sale',
  VAS= 'VAS',

}